import { isDefinedString } from '../stringUtils';

export interface MatrikkelParts {
  cadastralUnit?: string | null;
  propertyUnit?: string | null;
  leaseholdUnit?: string | null;
}

/**
 * Formats the Norwegian cadastral identifier ("matrikkel") as `kommune-gnr/bnr`
 * (e.g. `3203-29/190`). For PlacePoint-onboarded buildings the cadastral parts are
 * stored as CadastralUnit=kommune, PropertyUnit=gnr, LeaseholdUnit=bnr.
 *
 * @param parts The cadastral parts to format
 * @returns The formatted matrikkel string, or `undefined` when any part is missing
 */
export const formatMatrikkel = (parts?: MatrikkelParts | null): string | undefined => {
  if (
    isDefinedString(parts?.cadastralUnit) &&
    isDefinedString(parts?.propertyUnit) &&
    isDefinedString(parts?.leaseholdUnit)
  ) {
    return `${parts?.cadastralUnit}-${parts?.propertyUnit}/${parts?.leaseholdUnit}`;
  }
  return undefined;
};
